import { render, staticRenderFns } from "./PlansAddEditDialog.vue?vue&type=template&id=63a97e45&scoped=true&"
import script from "./PlansAddEditDialog.vue?vue&type=script&lang=js&"
export * from "./PlansAddEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlansAddEditDialog.vue?vue&type=style&index=0&id=63a97e45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a97e45",
  null
  
)

export default component.exports